import { CheckCircle, Circle, CircleNotch } from 'phosphor-react';
import { twMerge } from 'tailwind-merge';
import type { PasswordRequirement } from '@dill/dill-shared';

export const AppPasswordRequirements = ({
  requirements,
  className = '',
}: {
  requirements: PasswordRequirement[];
  className?: string;
}) => {
  return (
    <ul className={twMerge('flex flex-col gap-1', className)}>
      {requirements.map((requirement) => (
        <li key={requirement.key} className="flex items-center gap-1.5 text-left">
          {requirement.isPending ? (
            <CircleNotch size={14} className="GREY_500-CLR shrink-0 animate-spin" />
          ) : requirement.isMet ? (
            <CheckCircle size={14} weight="fill" className="SUCCESS_500-CLR shrink-0" />
          ) : (
            <Circle size={14} className="GREY_400-CLR shrink-0" />
          )}
          <span
            className={twMerge('text-2xs', requirement.isMet ? 'SUCCESS_700-CLR' : 'GREY_600-CLR')}>
            {requirement.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
